import React, { useState, useEffect } from 'react'
import useMobileDetect from 'helpers/mobile-detect'

import styles from './about-meet-coach.module.scss'

export default function AboutMeetCoach (props) {
  const currentDevice = useMobileDetect()
  const [imageUrl, setImageUrl] = useState('/static/images/about/bg-meet-your-coach.png')
  const bgImage = 'url(' + imageUrl + ') center center/cover no-repeat #000000'

  useEffect(() => {
    if (currentDevice.isMobile() && currentDevice.width < 768) {
      setImageUrl('/static/images/about/bg-m-meet-your-coach.png')
    } else {
      setImageUrl('/static/images/about/bg-meet-your-coach.png')
    }
  }, [currentDevice.width])

  return (
    <section className={styles['meet-your-coach']} style={{ background: bgImage }}>
      <div className='container'>
        <div className='row'>
          <div className={styles['meet-your-coach__card-item'] + ' col-12 col-md-6'}>
            <h4>MEET YOUR COACH</h4>
            <p className={styles['meet-your-coach__text-top']}>
            I’m Mike Dolce, a professional weight management
            coach and UFC trainer with over 20 years of
            experience helping thousands of pro athletes as well
            as ordinary people hit their weight loss goals.
            </p>
            <p>
            I know how hard it can be to access the right
            information and stay motivated. As a professional
            coach, speaker, husband and father, and someone
            who’s <span>been in your shoes</span>,  I’ve made it my mission to
            empower people across the globe to look & feel the
            best they’ve felt in their lives.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
